import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Avatar,
  TextField,
  Button,
  Container,
  Alert,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  BottomNavigation,
  BottomNavigationAction,
} from "@mui/material";
import {
  Notifications as NotificationsIcon,
  Chat as ChatIcon,
  AccountCircle as AccountCircleIcon,
  NotificationsActive as NotificationsActiveIcon,
  CalendarToday as CalendarTodayIcon,
  Payment as PaymentIcon,
  Home as HomeIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import axios from "axios";

const AdminNotifPerso = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState(null);

  const baseUrl = process.env.REACT_APP_APP_URL;
  const token = localStorage.getItem("CC_Token");
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user ? user.id : null;
  
  const handleLogout = () => {
    localStorage.removeItem("CC_Token");
    localStorage.removeItem("user");
    toast.success("Vous avez été déconnecté avec succès.", {
      position: "top-right",
      autoClose: 3000,
    });
    setTimeout(() => navigate("/login"), 4000);
  };

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const filtered = response.data.filter(
        (user) => user.role === "member" && user.isActive === 1
      );
      setUsers(filtered);
      setFilteredUsers(filtered);
    } catch (error) {
      console.error("Erreur lors de la récupération des utilisateurs:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = users.filter(
      (user) =>
        user.name.toLowerCase().includes(value) ||
        user.email.toLowerCase().includes(value)
    );
    setFilteredUsers(filtered);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const token = localStorage.getItem("CC_Token");

    if (!selectedUserId) {
      setError("Veuillez sélectionner un utilisateur.");
      return;
    }

    axios
      .post(
        `${baseUrl}/api/notifications/byUser`,
        { user_id: selectedUserId, title, message },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        toast.success("Notification envoyée avec succès !", {
          position: "top-right",
          autoClose: 3000,
        });
        setTitle("");
        setMessage("");
        setSelectedUserId("");
        setError(null);
      })
      .catch((err) => {
        console.error(err);
        setError("Erreur lors de l'envoi de la notification. Réessayez.");
      });
  };
  const handleProfile = () => {
    user.role =="admin" ? navigate("/ProfileAdmin") : navigate("/Profile");  // Redirection vers la page de profil
  };
  const handleNavigateToNotifications = () => {
    navigate("/AdminGetNotifs");
  };

  return (
    <div className="app">
      {/* Toast Container */}
      <ToastContainer />

      {/* Header */}
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar
            alt="Logo"
            src={"../assets/cej.png"}
            sx={{ width: 40, height: 40, marginRight: "0.5rem" }}
          />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "#ffffff",
            }}
          >
            Club Équestre Jafoura
          </Typography>
          <IconButton color="inherit" onClick={handleNavigateToNotifications}>
            <NotificationsIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleProfile}>
            <AccountCircleIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Main Content with scrollable area */}
      <Container
        maxWidth="xs"
        sx={{
          marginTop: "64px", // Height of the header
          marginBottom: "56px", // Height of the footer
          flex: 1, // Allow the content to take the remaining space
          padding: "1rem",
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: 3,
          overflowY: "auto", // Allow scrolling if content overflows
        }}
      >
        <Typography
          variant="h5"
          sx={{
            textAlign: "center",
            marginBottom: "1rem",
            color: "#003366",
            fontWeight: "bold",
          }}
        >
          Nouvelle Notification Personnalisée
        </Typography>
        <NotificationsActiveIcon
          sx={{
            fontSize: 40,
            color: "red",
            display: "block",
            margin: "0 auto",
          }}
        />
        {error && (
          <Alert severity="error" sx={{ marginBottom: "1rem" }}>
            {error}
          </Alert>
        )}
        <form onSubmit={handleSubmit}>
          <TextField
            label="Recherche"
            variant="outlined"
            fullWidth
            margin="normal"
            value={searchTerm}
            onChange={handleSearch}
            placeholder="Rechercher par nom ou email"
            sx={{ marginBottom: "1rem" }}
          />
          <FormControl fullWidth margin="normal" sx={{ marginBottom: "1rem" }}>
            <InputLabel>Utilisateur</InputLabel>
            <Select
              value={selectedUserId}
              onChange={(e) => setSelectedUserId(e.target.value)}
              label="Utilisateur"
            >
              {filteredUsers.map((user) => (
                <MenuItem key={user.id} value={user.id}>
                  {user.name} - {user.email}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Titre"
            variant="outlined"
            fullWidth
            margin="normal"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            sx={{ marginBottom: "1rem" }}
          />
          <TextField
            label="Message"
            variant="outlined"
            fullWidth
            margin="normal"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            multiline
            rows={4}
            sx={{ marginBottom: "1rem" }}
          />
          <Button
            variant="contained"
            fullWidth
            type="submit"
            sx={{
              backgroundColor: "#003366",
              color: "white",
              padding: "0.75rem",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#002244",
              },
            }}
          >
            Envoyer
          </Button>
        </form>
      </Container>

      {/* Footer */}
      <Box sx={{ position: "fixed", bottom: 0, width: "100%" }}>
        <BottomNavigation
          sx={{
            backgroundColor: "#003366",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 1rem",
            height: "56px", // Height of footer
          }}
        >
          <BottomNavigationAction
            label="Calendrier"
            icon={<CalendarTodayIcon sx={{ fontSize: 25, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/AdminChrono")}
          />
   <BottomNavigationAction
                label="Home"
                icon={<HomeIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
                sx={{ color: "#ffffff", minWidth: "auto" }}
                onClick={() => navigate(user.role === "admin" ? "/admin" : "/InstructorHome")
                }
              />
              <BottomNavigationAction
                label="Paiement"
                icon={<PaymentIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
                sx={{ color: "#ffffff", minWidth: "auto" }}
                  onClick={() => navigate(user.role === "admin" ? "/AdminPaiment" : "/InstructorHome")
                }
              />
            </BottomNavigation>
      </Box>
    </div>
  );
};

export default AdminNotifPerso;
